import type { Colors } from '../theme';
import { scrollToId } from '../scroll';

interface NavItem {
  id: string;
  shortLabel: string;
}

interface Props {
  items: NavItem[];
  activeId: string;
  colors: Colors;
}

export default function MobileNav({ items, activeId, colors }: Props) {
  return (
    <nav className="mobile-nav" style={{
      position: "fixed",
      // clears the iOS home indicator on devices that report a safe area
      bottom: "calc(18px + env(safe-area-inset-bottom, 0px))",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 10,
      display: "flex",
      alignItems: "center",
      // never wider than the screen; scrolls sideways rather than overflowing it
      maxWidth: "calc(100vw - 24px)",
      overflowX: "auto",
      background: colors.cardBg,
      border: `1px solid ${colors.cardBorder}`,
      borderRadius: 999,
      padding: "4px",
      boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
    }}>
      {items.map(({ id, shortLabel }) => {
        const isActive = id === activeId;
        return (
          <button
            key={id}
            onClick={() => scrollToId(id)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              fontFamily: "'0xProto', 'JetBrains Mono', monospace",
              fontSize: 12,
              color: isActive ? colors.fg : colors.muted,
              fontWeight: isActive ? 600 : 400,
              // ~40px tall so the tap target is finger-sized
              padding: "11px 12px",
              transition: "color .2s ease",
              whiteSpace: "nowrap",
            }}
          >
            {shortLabel}
          </button>
        );
      })}
    </nav>
  );
}
